import * as types from './types';

export const setSubdomain = (subdomain: string | null) => ({
  type: types.SET_SUBDOMAIN,
  payload: subdomain
});

export const clearSubdomain = () => ({
  type: types.CLEAR_SUBDOMAIN
});

